<template>
  <div>
    <div class="relative mt-2 rounded-md shadow-sm">
      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 512 512">
          <path
              d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
        </svg>
      </div>
      <input v-model="searchTerm" type="text" name="search" id="filesystem-search"
             class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brand sm:text-sm sm:leading-6"
             placeholder="Search files / folders...">
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      searchTerm: ''
    }
  },
  watch: {
    searchTerm: _.debounce(function () {
      this.handleSearch();
    }, 500),
  },
  methods: {
    handleSearch() {
      const searchTerm = this.searchTerm.trim();
      if (searchTerm.length > 2) {
        this.$emit('searching', searchTerm);
      } else {
        this.$emit('searchCleared');
      }
    }
  }
}
</script>
